// src/store/slices/requestIssuanceSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import requestIssuanceApi from "api/requestIssuanceApi";

export const fetchRequests = createAsyncThunk(
  "requestIssuance/fetchAll",
  async ({ page = 1, pageSize = 10, search = "" }, { rejectWithValue }) => {
    try {
      const res = await requestIssuanceApi.getAll(page, pageSize, search);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to load requests"
      );
    }
  }
);

export const createRequest = createAsyncThunk(
  "requestIssuance/create",
  async (data, { rejectWithValue }) => {
    try {
      return await requestIssuanceApi.create(data);
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create request");
    }
  }
);

export const updateRequest = createAsyncThunk(
  "requestIssuance/update",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      return await requestIssuanceApi.update(id, data);
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update request");
    }
  }
);

export const deleteRequest = createAsyncThunk(
  "requestIssuance/delete",
  async (id, { rejectWithValue }) => {
    try {
      await requestIssuanceApi.delete(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to delete request"
      );
    }
  }
);

// export const markInProgress = createAsyncThunk(
//   "requestIssuance/markInProgress",
//   async (id, { rejectWithValue }) => {
//     try {
//       return await requestIssuanceApi.markInProgress(id);
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.detail || "Failed to mark as in progress"
//       );
//     }
//   }
// );

// src/store/slices/requestIssuanceSlice.js

export const markInProgress = createAsyncThunk(
  "requestIssuance/markInProgress",
  async ({ id, expected_completion_datetime }, { rejectWithValue }) => {
    try {
      return await requestIssuanceApi.markInProgress(id, expected_completion_datetime);
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to mark as in progress"
      );
    }
  }
);

export const approveRequest = createAsyncThunk(
  "requestIssuance/approve",
  async ({ id, items }, { rejectWithValue }) => {
    try {
      return await requestIssuanceApi.approve(id, items);
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || "Failed to approve");
    }
  }
);

export const rejectRequest = createAsyncThunk(
  "requestIssuance/reject",
  async ({ id, reason }, { rejectWithValue }) => {
    try {
      return await requestIssuanceApi.reject(id, reason);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || "Failed to reject");
    }
  }
);

export const exportRequests = createAsyncThunk(
  "requestIssuance/export",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await requestIssuanceApi.exportCsv();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `requests_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      return rejectWithValue("Export failed");
    }
  }
);

// CORRECT ACKNOWLEDGEMENT THUNK (Fixed!)
export const acknowledgeRequest = createAsyncThunk(
  "requestIssuance/acknowledge",
  async ({ id, is_accepted, notes }, { rejectWithValue }) => {
    try {
      await requestIssuanceApi.acknowledge(id, { is_accepted, notes });
      return { id, is_accepted, notes };
    } catch (e) {
      const errorMsg =
        e.response?.data?.detail ||
        e.response?.data?.error ||
        e.response?.data ||
        "Failed to acknowledge asset assignment";
      return rejectWithValue(errorMsg);
    }
  }
);

const requestIssuanceSlice = createSlice({
  name: "requestIssuance",
  initialState: {
    requests: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    isLoading: false,
    error: null,
    pendingAcknowledgement: null,
  },
  // reducers: {
  //   clearError: (state) => {
  //     state.error = null;
  //   },
  //   // ← ADD THESE NEW REDUCERS
  //   setRealtimeRequests: (state, action) => {
  //     state.requests = action.payload;
  //   },
  //   setRealtimeRequest: (state, action) => {
  //     const payload = action.payload;
  //     const idx = state.requests.findIndex((r) => r.id === payload.id);
  //     if (idx === -1) {
  //       state.requests.unshift(payload);
  //       state.pagination.count += 1;
  //     } else {
  //       state.requests[idx] = payload;
  //     }
  //   },
  // },

  // Replace your current reducers with this:
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    // setRealtimeRequests: (state, action) => {
    //   if (Array.isArray(action.payload)) {
    //     state.requests = action.payload;
    //     state.pagination.count = action.payload.length;
    //   }
    // },
    // setRealtimeRequest: (state, action) => {
    //   const request = action.payload;
    //   const idx = state.requests.findIndex((r) => r.id === request.id);

    //   if (idx === -1) {
    //     state.requests.unshift(request);
    //     state.pagination.count += 1;
    //   } else {
    //     state.requests[idx] = request;
    //   }
    // },
    // EXACT SAME LOGIC AS TICKET SLICE — SAFE, NO DUPLICATES
    setRealtimeRequests: (state, action) => {
      const payload = action.payload;

      if (Array.isArray(payload)) {
        payload.forEach((incoming) => {
          const idx = state.requests.findIndex((r) => r.id === incoming.id);
          if (idx !== -1) {
            state.requests[idx] = { ...state.requests[idx], ...incoming };
          } else {
            state.requests.unshift(incoming);
          }
        });
      } else if (payload?.id) {
        const idx = state.requests.findIndex((r) => r.id === payload.id);
        if (idx !== -1) {
          state.requests[idx] = { ...state.requests[idx], ...payload };
        } else {
          state.requests.unshift(payload);
        }
      }
    },

    // Acknowledgement actions
    // In requestIssuanceSlice.js → reducers
    setPendingRequestAck: (state, action) => {
      state.pendingAcknowledgement = {
        requestId: action.payload.id, // ← matches payload.id
        request: action.payload.data, // ← matches payload.data
        open: true,
      };
    },
    clearPendingRequestAck: (state) => {
      state.pendingAcknowledgement = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchRequests.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(fetchRequests.fulfilled, (s, a) => {
        s.isLoading = false;
        s.requests = a.payload.data || [];
        s.pagination = a.payload.pagination || { count: 0, page_size: 10 };
      })
      .addCase(fetchRequests.rejected, (s, a) => {
        s.isLoading = false;
        s.error = a.payload;
      })

      .addCase(createRequest.fulfilled, (s, a) => {
        s.requests.unshift(a.payload);
        s.pagination.count += 1;
      })
      .addCase(updateRequest.fulfilled, (s, a) => {
        const idx = s.requests.findIndex((r) => r.id === a.payload.id);
        if (idx > -1) s.requests[idx] = a.payload;
      })
      .addCase(deleteRequest.fulfilled, (s, a) => {
        s.requests = s.requests.filter((r) => r.id !== a.payload);
        s.pagination.count -= 1;
      })
      .addCase(markInProgress.fulfilled, (s, a) => {
        const idx = s.requests.findIndex((r) => r.id === a.payload.id);
        if (idx > -1) s.requests[idx] = a.payload;
      })
      .addCase(markInProgress.rejected, (s, a) => {
        s.error = a.payload;
      })
      .addCase(approveRequest.fulfilled, (s, a) => {
        const idx = s.requests.findIndex((r) => r.id === a.payload.id);
        if (idx > -1) s.requests[idx] = a.payload;
      })
      .addCase(rejectRequest.fulfilled, (s, a) => {
        const idx = s.requests.findIndex((r) => r.id === a.payload.id);
        if (idx > -1) s.requests[idx] = a.payload;
      })

      // ACKNOWLEDGEMENT - CORRECT HANDLING
      .addCase(acknowledgeRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        const { id, is_accepted } = action.payload;
        const idx = state.requests.findIndex((r) => r.id === id); // ← FIXED: was state.list
        if (idx !== -1) {
          state.requests[idx].status = is_accepted
            ? "acknowledged"
            : "rejected";
          state.requests[idx].is_acknowledged = is_accepted;
        }
        state.pendingAcknowledgement = null; // Close modal
      })
      .addCase(acknowledgeRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearError,
  setRealtimeRequests,
  setPendingRequestAck,
  clearPendingRequestAck,
} = requestIssuanceSlice.actions;
export default requestIssuanceSlice.reducer;
